import errorRoutes from '@/router/routes/error';
import routes from '@/router/concatter';
import Router from 'vue-router';
import mainOidc from '@/auth';
import Vue from 'vue';


Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes,
});

mainOidc.useRouter(router);

// Make sure the error route is always added at the end. This makes sure all routes are checked before showing a 404 error.
router.addRoutes(errorRoutes);

export default router;
